
import News from "./News";

export {
    News
};
